import script from "./ModalsModals.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalsModals.vue?vue&type=script&setup=true&lang=js"

import "./ModalsModals.vue?vue&type=style&index=0&id=e43cbf9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e43cbf9a"]])

export default __exports__